import * as React from 'react';
import { themePalette } from '../../../utils/theme-palette';

const DashboardIcon = ({ size = 24, active = false }) => {
  const blue = themePalette.blue;
  const gray = themePalette.gray;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 28 28" fill="none">
      <g id="nature-ecology-green-house--glass-building-plants-crops-produce-farm" clipPath="url(#clip0_59_5326)">
        <g id="Group">
          <path
            id="Vector"
            d="M27 13.88C27.0019 13.6024 26.946 13.3274 26.8358 13.0726C26.7256 12.8178 26.5636 12.5888 26.36 12.4L14 1L1.64005 12.4C1.4365 12.5888 1.27447 12.8178 1.16429 13.0726C1.0541 13.3274 0.998167 13.6024 1.00005 13.88V25C1.00005 25.5304 1.21076 26.0391 1.58583 26.4142C1.9609 26.7893 2.46961 27 3.00005 27H25C25.5305 27 26.0392 26.7893 26.4143 26.4142C26.7893 26.0391 27 25.5304 27 25V13.88Z"
            fill={active ? blue : 'none'}
            stroke={active ? 'white' : blue}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path id="Vector_2" d="M14 16V1" stroke={active ? 'white' : gray} strokeLinecap="round" strokeLinejoin="round" />
          <path id="Vector_3" d="M1 16H27" stroke={active ? 'white' : gray} strokeLinecap="round" strokeLinejoin="round" />
          <path id="Vector_4" d="M1 21.5H8" stroke={active ? 'white' : gray} strokeLinecap="round" strokeLinejoin="round" />
          <path id="Vector_5" d="M20 21.5H27" stroke={active ? 'white' : gray} strokeLinecap="round" strokeLinejoin="round" />
          <path id="Vector_6" d="M8 26.9991V6.53906" stroke={active ? 'white' : gray} strokeLinecap="round" strokeLinejoin="round" />
          <path id="Vector_7" d="M20 26.9991V6.53906" stroke={active ? 'white' : gray} strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_59_5326">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default DashboardIcon;
